import Vue from 'vue'

import FormOption from '@/components/elements/FormOption';
Vue.component('form-option', FormOption);